import { render, staticRenderFns } from "./BuyNow.vue?vue&type=template&id=2164da9c&scoped=true&"
import script from "./BuyNow.vue?vue&type=script&lang=ts&"
export * from "./BuyNow.vue?vue&type=script&lang=ts&"
import style0 from "./BuyNow.vue?vue&type=style&index=0&id=2164da9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2164da9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VChip,VChipGroup,VDialog})
